/** A unidade UTF-16 no índice `i`, o que os digests FNV-1a hasheiam. No
 *  surrogate alto de um par, `codePointAt` devolve o code point astral
 *  inteiro: reconstrói-se o surrogate alto para o digest não mudar. */
export function utf16UnitAt(value: string, i: number): number {
  const code = value.codePointAt(i) ?? 0;
  return code > 0xffff ? 0xd800 + ((code - 0x10000) >> 10) : code;
}
